"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeedMoreInfoWarning = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const Wrapper = styled_components_1.default.div.withConfig({ displayName: "reports-Wrapper", componentId: "reports-eknebg" }) `
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.sebastianRed200};
  display: flex;
  flex-flow: column nowrap;
  padding: 16px;

  @media (${base_react_components_1.theme.forLargerThanPhone}) {
    padding: 24px 12px;
  }
`;
const StyledHeader = (0, styled_components_1.default)(base_react_components_1.Header).withConfig({ displayName: "reports-StyledHeader", componentId: "reports-16hoyyx" }) `
  color: ${({ theme }) => theme.neutral500};
  font-weight: bold;
  line-height: 28px;
  margin-bottom: 16px;
`;
const BodyCopy = styled_components_1.default.div.withConfig({ displayName: "reports-BodyCopy", componentId: "reports-pe0ut" }) `
  display: flex;
  flex-flow: column nowrap;
  color: ${({ theme }) => theme.neutral500};
  font-size: 16px;
  line-height: 25px;
`;
/** Need More Info Warning is a transparent card with a red border */
const NeedMoreInfoWarning = (_a) => {
    var { className, title = '', children } = _a, rest = __rest(_a, ["className", "title", "children"]);
    return (react_1.default.createElement(Wrapper, Object.assign({ className: className }, rest),
        title && react_1.default.createElement(StyledHeader, { size: "sm" }, title),
        children && react_1.default.createElement(BodyCopy, null, children)));
};
exports.NeedMoreInfoWarning = NeedMoreInfoWarning;
exports.default = (0, styled_components_1.default)(exports.NeedMoreInfoWarning).withConfig({ componentId: "reports-14bt4x0" }) ``;
//# sourceMappingURL=index.js.map